import { h } from 'preact'
import ButtonControl from '../button-control'

const reloadPage = () => {
  window.location.reload()
}

interface CustomButton {
  title: string,
  variant: string,
  url?: string,
  customClass?: string,
  nodeName?: string,
  action?: Function | string
}

interface SaveProps1 {
  saveCallback?: undefined,
  disableSaveButton: true,
}

interface SaveProps2 {
  saveCallback?: () => void,
  disableSaveButton?: false,
}

interface Props {
  title: string,
  cancelCallback?: Function,
  isLoading?: boolean,
  hasBreadcrumb?: boolean,
  breadcrumbLink?: string,
  breadcrumbText?: string,
  disableCancelButton?: boolean,
  customButtons?: Array<CustomButton>
}

interface Props1 extends Props, SaveProps1 {}
interface Props2 extends Props, SaveProps2 {}

const Header = ({
  title,
  saveCallback = () => {},
  cancelCallback = reloadPage,
  isLoading = false,
  hasBreadcrumb = false,
  breadcrumbLink,
  breadcrumbText,
  disableCancelButton = false,
  disableSaveButton = false,
  customButtons = []
}: Props1 | Props2) => {
  const headerClass = `control-header${hasBreadcrumb ? ' control-header--breadcrumb' : ''}`

  return (
    <div class={headerClass}>
      <div class='control-header__texts-container'>
        {
          hasBreadcrumb && (
            <span class='control-header__breadcrumb'>
              <i class='fa fa-chevron-left' />
              <a class='control-header__breadcrumb-link' href={breadcrumbLink}>{breadcrumbText}</a>
            </span>
          )
        }
        <h2 class='control-header__title'>{title}</h2>
      </div>
      <div class='control-header__buttons'>
        {
          !disableCancelButton && (
            <ButtonControl
              variant='default'
              title='Cancel'
              onClick={() => cancelCallback()}
              class={'js-cancel'}
            />
          )
        }
        {
          !disableSaveButton && (
            <ButtonControl
              variant='success'
              title='Save Changes'
              onClick={() => saveCallback()}
              disabled={isLoading}
              isLoading={isLoading}
              class='js-submit'
            />
          )
        }
        {(customButtons && customButtons.length)
          ? customButtons[0].nodeName
            ? customButtons
            : customButtons.map(({
              url,
              customClass,
              variant,
              title,
              action
            }) => {
              if (!action && !url) return null

              return (
                <a class='control-header__button-wrapper' href={url}>
                  <ButtonControl
                    variant={variant}
                    class={customClass}
                    title={title}
                    onClick={action}
                  />
                </a>
              )
            })
          : null}
      </div>
    </div>
  )
}

export default Header
